/**
 * Labstep
 *
 * @module components/Organization/Item
 * @desc Organization Item component
 */

import { OrganizationLogo } from 'labstep-web/components/Organization/Logo';
import { ICONS } from 'labstep-web/constants/icons';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { OrganizationItemProps } from './types';

export const OrganizationItem: React.FC<OrganizationItemProps> = ({
  organization,
  truncate,
}) => (
  <Flex
    vAlignContent="center"
    style={{
      maxWidth: truncate ? '400px' : 'none',
    }}
  >
    {organization.logo_url ? (
      <OrganizationLogo organization={organization} size="mini" />
    ) : (
      <Icon name={ICONS.organization.primary} />
    )}
    <span className={styles.name}>{organization.name}</span>
  </Flex>
);
